import { putResource } from './client'

const toHex = (buffer: ArrayBuffer): string =>
  Array.from(new Uint8Array(buffer))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('')

export type UploadResourceParams = {
  data: Blob
  extension: string
}

const uploadResource = async ({ data, extension }: UploadResourceParams): Promise<string> => {
  const buffer = await data.arrayBuffer()
  const sha256hex = toHex(await crypto.subtle.digest('SHA-256', buffer))
  const resourceKey = `${sha256hex}.${extension}`

  await putResource(resourceKey, new Uint8Array(buffer))

  return resourceKey
}

export default uploadResource
